/**
 * Mobile audio unlock helper.
 * Android WebView blocks autoplay/Web Audio until a user gesture occurs.
 * This module listens for the first interaction and unlocks all audio APIs.
 */

let unlocked = false;

export function isAudioUnlocked() {
  return unlocked;
}

export function unlockAudio() {
  if (unlocked) return;
  unlocked = true;

  // 1. Unlock Web Audio API
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (AC) {
      const ctx = new AC();
      if (ctx.state === 'suspended') {
        ctx.resume().catch(() => {});
      }
      const buffer = ctx.createBuffer(1, 1, 22050);
      const source = ctx.createBufferSource();
      source.buffer = buffer;
      source.connect(ctx.destination);
      source.start(0);
    }
  } catch (e) {
    console.warn('Web Audio unlock failed', e);
  }

  // 2. Unlock HTML5 Audio (plays a silent base64 wav)
  try {
    const silent = new Audio(
      'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA'
    );
    silent.play().catch(() => {});
  } catch (e) {
    console.warn('HTML5 Audio unlock failed', e);
  }

  // 3. Unlock Speech Synthesis
  try {
    if (window.speechSynthesis) {
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance('');
      u.volume = 0;
      window.speechSynthesis.speak(u);
    }
  } catch (e) {
    console.warn('Speech unlock failed', e);
  }

  // Remove listeners so we don’t run again
  document.removeEventListener('touchstart', unlockAudio, true);
  document.removeEventListener('touchend', unlockAudio, true);
  document.removeEventListener('click', unlockAudio, true);
  document.removeEventListener('keydown', unlockAudio, true);
}

export function initAudioUnlock() {
  if (typeof document === 'undefined') return;
  // Use capture so we catch the very first interaction even on nested elements
  document.addEventListener('touchstart', unlockAudio, true);
  document.addEventListener('touchend', unlockAudio, true);
  document.addEventListener('click', unlockAudio, true);
  document.addEventListener('keydown', unlockAudio, true);
}
